import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import OperationsDashboardPage from "@/pages/admin/OperationsDashboardPage";

export const Route = createFileRoute("/_admin/admin/operations")({
  head: () => pageHead("Admin · Operations", "AKIVA admin · operations portal.", "/admin/operations", true),
  component: OperationsDashboardPage,
});
